<template>
  <button
    class="ui-btn"
    :class="[variantClass, { 'is-loading': loading }]"
    :disabled="disabled || loading"
    @click="$emit('click')"
    type="type"
  >
    <span v-if="!loading">
      <slot />
    </span>
    <span v-else>Loading…</span>
  </button>
</template>

<script>
export default {
  name: "UiButton",
  props: {
    variant: { type: String, default: "brand" },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    type: { type: String, default: "button" },
  },
  computed: {
    variantClass() {
      return `ui-btn--${this.variant}`;
    },
  },
};
</script>

<style scoped>
.ui-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 54px;
  border: 0;
  cursor: pointer;
  border-radius: 5px;
  font: 700 var(--fs-20) / 1 var(--font-sans);
  letter-spacing: -2px;
}

.ui-btn--brand {
  background: var(--brand);
  color: #000;
}

.ui-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
